import type { ArtifactCanvasConfig } from '@yeshuman/sdk'
import type { MutableRefObject } from 'react'
import type { Opportunity } from '../../hooks/use-opportunities'
import { ApplicationApplyCanvas } from './application-apply-canvas'

type OpenApplyCanvasArgs = {
  opportunity: Opportunity
  openCanvas: (config: ArtifactCanvasConfig) => void
  closeCanvas: () => void
  applyCanvasKeyRef: MutableRefObject<number>
  onApplied?: () => void
  keyPrefix?: string
}

export function openApplicationApplyCanvas({
  opportunity,
  openCanvas,
  closeCanvas,
  applyCanvasKeyRef,
  onApplied,
  keyPrefix = 'apply',
}: OpenApplyCanvasArgs) {
  applyCanvasKeyRef.current += 1
  openCanvas({
    title: 'Apply to job opportunity',
    preventAutoFocus: true,
    content: (
      <ApplicationApplyCanvas
        key={`${keyPrefix}-${opportunity.id}-${applyCanvasKeyRef.current}`}
        opportunity={opportunity}
        onClose={closeCanvas}
        onApplied={onApplied}
      />
    ),
  })
}
